import React, { useEffect, useRef } from 'react';

import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { getBookings } from '../request/components/service';

import DetailBooking from './DetailBooking';
require('moment/locale/es');

const localizer = momentLocalizer(moment);

const allViews = Object.keys(Views).map(k => Views[k]);
const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const useStyles = makeStyles(theme => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: 'none',
  },
}));

function parseColorStatus(status) {
  switch (status) {
    case 'requested':
      return '#F7931E';
    case 'approved':
      return '#004D71';
    case 'denied':
      return '#F00';
    case 'cancelled':
      return '#999';
    default:
      return '#8CC63F';
  }
}

function parseBookingEvents(bookings) {
  return bookings.map(item => {
    return {
      id: item.id,
      title: item.id,
      start: new Date(item.departure_datetime),
      end: new Date(item.return_datetime ? item.return_datetime : item.departure_datetime),
      hexColor: parseColorStatus(item.status)
    };
  });
}

function Home() {
  // const localizer = BigCalendar.momentLocalizer(moment); // or globalizeLocalizer
  const classes = useStyles();
  const loggedUser = JSON.parse(localStorage.currentUser);
  const [isSelected, setIsSelected] = React.useState(false);
  const [selectedEvent, setSelectedEvent] = React.useState({});
  const [viewDetail, setViewDetail] = React.useState(false);
  const [updateBooking, setUpdateBooking] = React.useState({ isUpdated: false, bookingId: null });

  const [bookings, setBookings] = React.useState({
    isLoading: true,
    events: [],
    list: [],
  });


  const [dateRange, setDateRange] = React.useState({
    start: moment().startOf("month").startOf('week').format("YYYY-MM-DD"),
    end: moment().endOf("month").endOf("week").format("YYYY-MM-DD"),
  });

  const containerRef = useRef(null);

  const scrollToBottom = () => {
    setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.scrollTop = containerRef.current.scrollHeight;
      }
    }, 100);
  };

  async function loadBookings(start, end) {
    const response = await getBookings({dateRange: {start_date: start, end_date: end}});

    if (response && response.status === 200) {
      const events = parseBookingEvents(response.data);
      setBookings({
        ...bookings,
        isLoading: false,
        events: events.sort((a, b) => (a.id < b.id ? 1 : -1)),
        list: response.data,
      });
    }
  }

  function updateBookingList() {
    let list = bookings.list;
    let book = list.find(x => x.id === updateBooking.bookingId);
    // Business rule: 'requested' bookings are converted to 'denied' to indicate rejection,
    // while all other statuses are converted to 'cancelled' to indicate termination.
    book.status = book.status === 'requested' ? 'denied' : 'cancelled';
    const index = list.findIndex(x => x.id === updateBooking.bookingId);
    list[index] = book;

    setUpdateBooking({ isUpdated: false, bookingId: null });

    setBookings({
      ...bookings,
      list: list,
      events: parseBookingEvents(list),
    });
  }

  useEffect(() => {
    if (updateBooking.isUpdated) {
      updateBookingList();
    }
    if (bookings.isLoading) {
      loadBookings(dateRange.start, dateRange.end);
    }
  }, []);

  const handleRangeChange = (range) => {
    setIsSelected(false);
    if (Array.isArray(range)) {
      range = { start: range[0], end: range.at(-1) };
    }
  
    if (range?.start && range?.end) {
      const startDate = moment(range.start).format("YYYY-MM-DD");
      const endDate = moment(range.end).format("YYYY-MM-DD");
      loadBookings(startDate, endDate);
    }
  };

  const handledPropEvent = (event, start, end, isSelected) => {
    const style = {
      backgroundColor: event.hexColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: '#FFF',
      border: '0px',
      display: 'block',
    };
    return {
      style: style,
    };
  };

  const handleSelectEvent = async e => {
    setIsSelected(true);
    const booking = bookings.list.find(x => x.id === e.id);
    setSelectedEvent(booking);
    scrollToBottom();
  };

  const onClickViewDetail = () => {
    setViewDetail(!viewDetail);
    scrollToBottom();
  };

  
  if (updateBooking.isUpdated) {
    updateBookingList();
  }

  return (
    <>
      <h1>Mis Reservas</h1>
      <div className="reservations-container">
        <div className="calendar-container" ref={containerRef}>
          <Calendar
            events={bookings.events}
            views={allViews}
            step={60}
            showMultiDayTimes
            defaultDate={new Date()}
            localizer={localizer}
            eventPropGetter={handledPropEvent}
            onSelectEvent={handleSelectEvent}
            onRangeChange={handleRangeChange}
          />
        </div>
        {isSelected && (
          <div className='calendar-event-details'>
            <div>
              <p>
                {`${new Date(selectedEvent.departure_datetime).toLocaleDateString(
                  'es-CR',
                  options,
                )} Solicitud: ${selectedEvent.id} ${selectedEvent.status}`}
              </p>
              <Button
                className={classes.button}
                color="primary"
                onClick={e => onClickViewDetail()}
                startIcon={viewDetail ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              >
                Detalles
              </Button>
            </div>
            <hr />
            {viewDetail && (
              <DetailBooking
                userId={selectedEvent.user.id}
                bookingId={selectedEvent.id}
                status={selectedEvent.status}
                departureDatetime={selectedEvent.departure_datetime}
                returnDatetime={selectedEvent.return_datetime}
                travelType={selectedEvent.travel_type}
                origin={selectedEvent.origin}
                destination={selectedEvent.destination}
                secondDestination={selectedEvent.second_destination}
                secondOrigin={selectedEvent.second_origin}
                passengersNumber={selectedEvent.passengers_number}
                observations={selectedEvent.observations}
                service={selectedEvent.service}
                setUpdateBooking={setUpdateBooking}
              />
            )}
          </div>
        )}
      </div>

    </>
  );
}

export default Home;
